import React from 'react';
import Header from '../components/Header';

export default function LikedVideos() {
  return (
    <>
      <Header />
      <h1>LikedVideos</h1>
    </>
  );
}
